export default "__VITE_ASSET__DIdaQFNx__"